import React, { FormEvent, useReducer } from 'react';
import { Auth } from 'aws-amplify';
import { CognitoUser } from '@aws-amplify/auth';

import { useAlert } from 'components/message/AlertContext';
import profile from 'assets/icons/profile.svg';
import lock from 'assets/icons/lock.svg';
import Input from 'components/Inputs/TextInput';
import { Section } from 'views/Auth';
import { NButton } from '@innersource-nn/novoui-react';

type FormState = {
    username: string;
    password: string;
};

type FormAction = {
    key: 'username' | 'password';
    value: string;
};

const DEFAULT_FORM = {
    username: '',
    password: '',
};

type SignInFormProps = {
    setSection: (section: Section) => void;
    setUser: (username: CognitoUser) => void;
};

export default function SignInForm({ setSection, setUser }: SignInFormProps) {
    const [formData, setFormData] = useReducer(
        (state: FormState, action: FormAction): FormState => {
            const newState: FormState = { ...state };
            newState[action.key] = action.value;
            return newState;
        },
        DEFAULT_FORM,
    );

    const { openAlert } = useAlert();
    const onSubmit = (e: FormEvent) => {
        e.preventDefault();

        Auth.signIn({
            ...formData,
        })
            .then((data) => {
                if (data.challengeName === Section.NEW_PASSWORD_REQUIRED) {
                    setSection(Section.NEW_PASSWORD_REQUIRED);
                    setUser(data);
                }
            })
            .catch((e) =>
                openAlert({
                    message: e.message,
                    severity: 'alert',
                }),
            );
    };

    return (
        <form className="flex flex-col w-full gap-y-8">
            {/* TODO: this should be replaced with NInput */}
            <Input
                className="w-full"
                required
                placeholder="Username"
                value={formData.username}
                onChange={(e) =>
                    setFormData({
                        key: 'username',
                        value: e.target.value,
                    })
                }
                icon={profile}
            />
            {/* TODO: this should be replaced with NInput */}
            <Input
                className="w-full"
                required
                placeholder="Password"
                value={formData.password}
                onChange={(e) =>
                    setFormData({
                        key: 'password',
                        value: e.target.value,
                    })
                }
                icon={lock}
                type="password"
            />
            <NButton variant="fill" size="small" onClick={onSubmit}>
                Login
            </NButton>
        </form>
    );
}
